export default __webpack_public_path__ + "caae02769b7e9159d571c5a851547d10.png";